<template>
  <div
      :class="{
        'DISABLE': isDisabled
      }"
      :selenium="`pro-card:${index+1}`"
      class="PROCARD d-flex fw-wrap fd-column:d bg-white h-90">

    <div class="d-flex fd-row flex-1-1">
      <pro-card-header
          :public-profile-id="publicProfile.id"
          :avatar="logo"
          :is-selected="isSelected"
          :is-preselected="isPreselected"
          :is-touched="isTouched"
          :is-five-star="publicProfile.rating_average >= 4.5"
          :is-top-pro="isTopPro"
          @toggleSelection="toggleSelection"
      />

      <div class="PROCARD-CONTENT m-l-4">
        <div
            class="d-flex fd-column"
            :class="{
              'SELECTED': isSelected,
              'PRESELECTED': isPreselected,
              'TOUCHED': isTouched,
              'UNSELECTED': !isSelected
            }"
        >
          <div class=" d-flex fd-column">
            <div
                v-tooltip="{
                  content: publicProfile.service_provider.business_name
                }"
                class="PRO-NAME p-r-5">
              {{ publicProfile.service_provider.business_name }}
            </div>
            <div class="d-flex fd-row" @click="showInfoModal = true">
              <responsive-rating-stars
                  starSize="10px"
                  :value="publicProfile.rating_average"
                  selenium="star-rating-label"/>
              <div
                  class="REVIEWSTEXT"
                  selenium="reviews-label">
                <small>{{ publicProfile.rating_count }} total reviews</small>
              </div>
            </div>
            <div>
              <div class="d-flex PRICINGTEXTCONTACT black" v-if="this.pricingValue === false">
                Contact for Pricing
              </div>
              <div v-else>
                <span
                    v-if="!pricingFunction.unit &&
                    !pricingFunction.minimum_price&&!pricingFunction.maximum_price"
                    class=" d-flex PRICINGTEXTCONTACT black  ">
                  Contact for Pricing
                </span>
                <span
                    v-else-if="pricingFunction.unit &&
                      pricingFunction.minimum_price
                      &&pricingFunction.maximum_price
                    &&pricingFunction.maximum_price=== pricingFunction.minimum_price"
                    class=" d-flex PRICINGTEXT ">
                  ${{ pricingFunction.minimum_price }}
                  <span class="PERUNIT">
                    / {{ pricingFunction.unit }}
                  </span>
                </span>

                <span
                    v-else
                    class=" d-flex PRICINGTEXT ">
                  ${{ pricingFunction.minimum_price }}-{{ pricingFunction.maximum_price }}
                  <span class="PERUNIT">
                    / {{ pricingFunction.unit }}
                  </span>

                </span>
              </div>
            </div>
          </div>
          <pro-credentials @showInfoModal="showInfoModal=true" :public-profile-id="publicProfile.id"/>
        </div>
      </div>
    </div>

    <pro-info-modal
        v-if="showInfoModal"
        :public-profile="publicProfile"
        :is-selected="isSelected"
        :is-preselected="isPreselected"
        :is-touched="isTouched"
        @toggleSelection="toggleSelection"
        @close="showInfoModal = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import find from 'lodash/find';
import ResponsiveRatingStars from '@/components/RatingStars/ResponsiveRatingStars.vue';
import ProCardHeader from './components/ProCardHeader';
import ProInfoModal from './components/ProInfoModal/ProInfoModal';
import ProCredentials from './components/ProCredentials';

export default {
  name: 'pro-card',
  components: {
    ProCardHeader,
    ProInfoModal,
    ProCredentials,
    ResponsiveRatingStars,
  },
  props: {
    publicProfileId: {
      type: Number,
      required: true,
    },
    serviceDisplayName: {
      type: String,
      required: true,
    },
    pricingValue: {
      type: Boolean,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data () {
    return {
      showInfoModal: false,
    };
  },
  computed: {
    ...mapGetters('jobrequest/matches', ['publicProfiles', 'selectedProfilesIds']),
    ...mapGetters('jobrequest', ['service']),

    publicProfile () {
      return find(this.publicProfiles, { id: this.publicProfileId });
    },
    isSelected () {
      return this.$store.getters['jobrequest/matches/isSelected'](this.publicProfileId);
    },

    isPreselected () {
      return this.$store.getters['jobrequest/matches/isPreSelected'](this.publicProfileId);
    },

    isTouched () {
      return this.$store.getters['jobrequest/matches/isTouched'](this.publicProfileId);
    },

    isDisabled () {
      return this.$store.getters['jobrequest/matches/isDisabled'](this.publicProfileId);
    },

    logo () {
      return this.publicProfile.service_provider.logo;
    },
    topPro () {
      const topProValue = this.$store.getters['jobrequest/matches/topPro'](this.publicProfileId).value;
      return JSON.parse(topProValue);
    },
    pricingFunction () {
      return this.publicProfile.services.find(o => o.name === this.service.display_name);
    },
    isTopPro () {
      if (this.topPro === null) {
        return false;
      }
      return this.topPro;
    },
  },
  mounted () {
    if (this.topPro !== null) {
      this.$emit('updateTopPro');
    }
  },
  methods: {
    toggleSelection () {
      if (this.isDisabled) {
        return;
      }
      this.$emit('toggleSelection');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .PROCARD {
    border: 1px solid $color-gray40;
    position: relative;
    cursor: pointer;
    //min-width: 200 px;
    height: 100px;

    &.DISABLE:after {
      @include absolute(0, 0, 0, 0);
      display: block;
      content: '';
      z-index: 20;
      opacity: .1;
      cursor: not-allowed;
    }
  }

  .PROCARD-CONTENT {
   display: flex;
    flex: 1 1 auto;
    justify-content: space-between;
    margin-top: 3px;

    @include desktop {
      @include margin-left(5);
    }

    &:hover {
      @include desktop {
        .CHECK {
          color: white;
          background-color: $color-depot;
          border-color: $color-depot;
        }
      }
    }
  }

  .PRO-NAME {
     min-width: 200px;
     text-transform: capitalize;
     font-weight: 700;
     font-size: 9px;
     padding-top:5px;
     overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .CHECK-CONTAINER{
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 50%;
    .CHECK{
      @include absolute(20%, 20%, auto, auto);
    }
  }

  .CHECK {
    @include absolute(10%, 5%, auto, auto);
    @include square(20px);
    border: 2px solid $color-gray60;
    border-radius: 50%;
    text-align: center;
    background-color: white;
    z-index: 20;
    line-height: 1;

    @include desktop {
      @include absolute(15%, 5%, auto, auto);
    }
  }
  .UNSELECTED {
  .CHECK {
      color: $color-gray60;
    }
  }

  .SELECTED:before {
    background-color: #fea972;
  }

  .SELECTED {
    .CHECK {
      color: white;
      background-color: $color-depot;
      border-color: $color-depot;
    }

    &:hover {
      @include desktop {
        .CHECK {
          color: white;
          background-color: $color-gray60;
          border-color: $color-gray60;
        }
      }
    }
  }
  .STARS {
    @include text-small;
    margin: $unit 0;

    @include tablet {
      font-size: inherit;
    }
  }
  .REVIEWSTEXT{
    font-size: 8px;
    font-weight: 400;
    color: #595959;
    margin-left: 10px;
  }
  .PRICINGTEXT{
    font-size: 14px;
    font-weight: 700;
    overflow: hidden;
    @include desktop{
      display: block;
    }
  }
    .PRICINGTEXTCONTACT{
    font-size: 8px;
    font-weight: 700;


    @include desktop{
      display: block;
    }
  }
  .PERUNIT{
    font-size: 8px;
    font-weight: 400;
    align-self: center;
    margin-left: 3px;
  }
</style>
